import { render, staticRenderFns } from "./integralruledetail.vue?vue&type=template&id=100d1d99&"
import script from "./integralruledetail.vue?vue&type=script&lang=js&"
export * from "./integralruledetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports